/**
 * 各工作域集合态左侧菜单配置
 * 进入具体对象（客户/方案/项目）后，切换为 workspaceMenus
 */
export type SideMenuItem = {
  key: string;
  path: string;
  label: string;
  icon?: string;
  children?: SideMenuItem[];
};

export const WORKBENCH_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'workbench-todo',
    path: '/workbench/todo',
    label: '我的待办',
    icon: 'unorderedList',
  },
  {
    key: 'workbench-risk',
    path: '/workbench/risk',
    label: '风险预警',
    icon: 'warning',
  },
  {
    key: 'workbench-activity',
    path: '/workbench/activity',
    label: '最近动态',
    icon: 'notification',
  },
  {
    key: 'workbench-dashboard',
    path: '/workbench/dashboard',
    label: '经营看板',
    icon: 'barChart',
  },
];

export const CUSTOMER_SIDE_MENU: SideMenuItem[] = [
  { key: 'customer-list', path: '/customer', label: '客户库', icon: 'team' },
  {
    key: 'customer-kanban',
    path: '/customer/kanban',
    label: '客户看板',
    icon: 'layout',
  },
  {
    key: 'customer-key-person',
    path: '/customer/key-person',
    label: '关键人库',
    icon: 'userSwitch',
  },
  {
    key: 'customer-existing-system',
    path: '/customer/existing-system',
    label: '现有系统库',
    icon: 'cluster',
  },
  {
    key: 'customer-tag',
    path: '/customer/tag',
    label: '客户标签',
    icon: 'tag',
  },
];

export const SOLUTION_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'solution-list',
    path: '/solution',
    label: '方案库',
    icon: 'fileSearch',
  },
  {
    key: 'solution-kanban',
    path: '/solution/kanban',
    label: '方案看板',
    icon: 'layout',
  },
  {
    key: 'solution-quote',
    path: '/solution/quote',
    label: '报价看板',
    icon: 'fileDone',
  },
  {
    key: 'solution-review',
    path: '/solution/review',
    label: '评审队列',
    icon: 'audit',
  },
  {
    key: 'solution-question',
    path: '/solution/question',
    label: '诊断题库',
    icon: 'questionCircle',
  },
  {
    key: 'solution-question-pack',
    path: '/solution/question-pack',
    label: '题包管理',
    icon: 'profile',
  },
  {
    key: 'solution-template',
    path: '/solution/template',
    label: '方案模板',
    icon: 'fileText',
  },
];

export const DELIVERY_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'delivery-overview',
    path: '/delivery/overview',
    label: '交付总览',
    icon: 'dashboard',
  },
  {
    key: 'delivery-project',
    path: '/delivery/project',
    label: '项目库',
    icon: 'folderOpen',
  },
  {
    key: 'delivery-kanban',
    path: '/delivery/kanban',
    label: '项目看板',
    icon: 'layout',
  },
  {
    key: 'delivery-my-task',
    path: '/delivery/my-task',
    label: '我的任务',
    icon: 'unorderedList',
  },
  {
    key: 'delivery-stage-gate',
    path: '/delivery/stage-gate',
    label: '阶段门队列',
    icon: 'schedule',
  },
  {
    key: 'delivery-risk',
    path: '/delivery/risk',
    label: '风险问题',
    icon: 'warning',
  },
  {
    key: 'delivery-resource',
    path: '/delivery/resource',
    label: '资源排期',
    icon: 'team',
  },
  {
    key: 'delivery-template',
    path: '/delivery/template',
    label: '项目模板',
    icon: 'fileText',
  },
  {
    key: 'delivery-model-settings',
    path: '/delivery/model-settings',
    label: '模型配置',
    icon: 'robot',
  },
];

export const SERVICE_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'service-overview',
    path: '/service',
    label: '服务看板',
    icon: 'dashboard',
  },
  {
    key: 'service-ticket',
    path: '/service/ticket',
    label: '服务工单',
    icon: 'tool',
  },
  {
    key: 'service-feedback',
    path: '/service/feedback',
    label: '客户反馈',
    icon: 'message',
  },
  {
    key: 'service-health',
    path: '/service/health',
    label: '客户健康度',
    icon: 'heartOutlined',
  },
  {
    key: 'service-usage',
    path: '/service/usage',
    label: '使用分析',
    icon: 'barChart',
  },
  {
    key: 'service-demand',
    path: '/service/demand',
    label: '二期需求',
    icon: 'bulb',
  },
  {
    key: 'service-renewal',
    path: '/service/renewal',
    label: '续费增购',
    icon: 'rise',
  },
  {
    key: 'service-report',
    path: '/service/report',
    label: '服务报告',
    icon: 'fileText',
  },
];

export const METHODOLOGY_CENTER_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'methodologyCenter.industryCases',
    path: '/asset/method/industry-cases',
    label: '行业案例库',
    icon: 'profile',
  },
  {
    key: 'methodologyCenter.problemPainPoints',
    path: '/asset/method/common-pain-points',
    label: '问题与痛点库',
    icon: 'warning',
  },
  {
    key: 'methodologyCenter.solutionPlaybooks',
    path: '/asset/method/solution-playbooks',
    label: '解决方案库',
    icon: 'rise',
  },
  {
    key: 'methodologyCenter.pilotScenes',
    path: '/asset/method/pilot-scenes',
    label: '试点场景库',
    icon: 'aim',
  },
  {
    key: 'methodologyCenter.talkTracks',
    path: '/asset/method/talk-tracks',
    label: '话术库',
    icon: 'message',
  },
  {
    key: 'methodologyCenter.failureReasons',
    path: '/asset/method/failure-reasons',
    label: '失败原因库',
    icon: 'bug',
  },
  {
    key: 'methodologyCenter.successPlaybooks',
    path: '/asset/method/success-playbooks',
    label: '成功打法库',
    icon: 'trophy',
  },
  {
    key: 'methodologyCenter.industryTemplates',
    path: '/asset/method/industry-templates',
    label: '行业模板库',
    icon: 'fileText',
  },
  {
    key: 'methodologyCenter.analysisLogics',
    path: '/asset/method/analysis-logics',
    label: '分析逻辑库',
    icon: 'partition',
  },
  {
    key: 'methodologyCenter.valueDescriptions',
    path: '/asset/method/value-descriptions',
    label: '价值描述库',
    icon: 'container',
  },
];

export const ASSET_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'asset-overview',
    path: '/asset',
    label: '资产总览',
    icon: 'dashboard',
  },
  {
    key: 'asset-method',
    path: '/asset/method',
    label: '方法资产',
    icon: 'book',
    children: METHODOLOGY_CENTER_SIDE_MENU,
  },
  {
    key: 'asset-solution',
    path: '/asset/solution',
    label: '方案资产',
    icon: 'rise',
  },
  {
    key: 'asset-design',
    path: '/asset/design',
    label: '设计资产',
    icon: 'highlight',
  },
  {
    key: 'asset-development',
    path: '/asset/development',
    label: '开发资产',
    icon: 'code',
  },
  {
    key: 'asset-testing',
    path: '/asset/testing',
    label: '测试资产',
    icon: 'bug',
  },
  {
    key: 'asset-delivery',
    path: '/asset/delivery',
    label: '交付资产',
    icon: 'cloud',
  },
  {
    key: 'asset-intelligence',
    path: '/asset/intelligence',
    label: '智能资产',
    icon: 'robot',
  },
  {
    key: 'asset-operation',
    path: '/asset/operation',
    label: '资产运营',
    icon: 'setting',
  },
];

export const ADMIN_SIDE_MENU: SideMenuItem[] = [
  {
    key: 'admin-organization',
    path: '/admin/organization',
    label: '组织权限',
    icon: 'team',
  },
  {
    key: 'admin-customer-project-config',
    path: '/admin/customer-project-config',
    label: '客户项目配置',
    icon: 'setting',
  },
  {
    key: 'admin-dictionary',
    path: '/admin/dictionary',
    label: '字典标签',
    icon: 'profile',
  },
  {
    key: 'admin-workflow',
    path: '/admin/workflow',
    label: '流程审批',
    icon: 'schedule',
  },
  {
    key: 'admin-pricing',
    path: '/admin/pricing',
    label: '计价规则',
    icon: 'calculator',
  },
  { key: 'admin-ai', path: '/admin/ai', label: 'AI 配置', icon: 'robot' },
  {
    key: 'admin-agent',
    path: '/admin/agent',
    label: 'Agent 配置',
    icon: 'thunderbolt',
  },
  {
    key: 'admin-integration',
    path: '/admin/integration',
    label: '集成配置',
    icon: 'api',
  },
  {
    key: 'admin-event-engine',
    path: '/admin/event-engine',
    label: '事件引擎',
    icon: 'shareAlt',
  },
  {
    key: 'admin-security',
    path: '/admin/security',
    label: '安全审计',
    icon: 'safety',
  },
];

export const DOMAIN_SIDE_MENUS: Record<string, SideMenuItem[]> = {
  workbench: WORKBENCH_SIDE_MENU,
  customer: CUSTOMER_SIDE_MENU,
  solution: SOLUTION_SIDE_MENU,
  delivery: DELIVERY_SIDE_MENU,
  service: SERVICE_SIDE_MENU,
  asset: ASSET_SIDE_MENU,
  admin: ADMIN_SIDE_MENU,
};
